"use client";

import React, { useRef, useState } from "react";

const Coupon = ({ paddle, items }) => {
  const [showCoupon, setShowCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponLoader, setCouponLoader] = useState("");
  const couponRef = useRef();

  const handleCheckCoupon = () => {
    setCouponLoader(true);

    setTimeout(() => {
      setCouponLoader(false);
      setShowCoupon(false);
    }, 1000);
    // return;
    paddle.Checkout.updateCheckout({
      items: items.map((item) => {
        return { quantity: item.quantity, price_id: item.price_id };
      }),
      discountCode: couponCode,
    });
  };

  const handleResetCoupon = () => {};

  return (
    <div className="jlt-py-3 jlt-border-b-[1px] jlt-border-[#EBEEF5]">
      <div ref={couponRef} className="jlt-flex jlt-items-center jlt-gap-4">
        <button onClick={() => setShowCoupon(!showCoupon)}>
          {showCoupon ? (
            <span className="jlt-text-sm jlt-text-[#3F475A]">Enter Coupon Code:</span>
          ) : (
            <span className="jlt-text-sm jlt-text-[#3F475A]">Have a Coupon?</span>
          )}
        </button>

        {showCoupon ? (
          <div className="jlt-flex jlt-items-center jlt-gap-2">
            <input
              type="text"
              value={couponCode || ""}
              onChange={(e) => setCouponCode(e.target.value)}
              className="jlt-py-[2px] jlt-px-2 jlt-w-[148px] jlt-bg-white jlt-border-[1px] jlt-border-[#EBEEF5] jlt-rounded-[2px] jlt-outline-none jlt-text-base jlt-text-[#72798A] jlt-font-normal"
            />

            <button
              onClick={() => handleCheckCoupon(couponCode)}
              className="jlt-py-[2px] jlt-px-2 jlt-text-[#256EFF] jlt-font-bold jlt-text-sm"
            >
              Apply
            </button>
          </div>
        ) : null}

        {/* {!showCoupon && !!couponCode ? (
          <button
            onClick={() => setShowCoupon(true)}
            className="jlt-text-[#256EFF] jlt-font-medium jlt-text-sm"
          >
            Try Again?
          </button>
        ) : null} */}

        {!showCoupon && !!couponCode ? (
          <button
            onClick={() => setShowCoupon(true)}
            className="jlt-text-[#256EFF] jlt-font-medium jlt-text-sm"
          >
            Edit Coupon?
          </button>
        ) : null}
      </div>

      {couponLoader ? (
        <span className="jlt-text-xs jlt-text-[#256EFF] jlt-font-medium">Processing...</span>
      ) : null}

      {/* {!showCoupon && !!couponCode ? (
        <div className="jlt-inline-flex jlt-items-center jlt-gap-3 jlt-border jlt-rounded-sm jlt-py-[2px] jlt-px-2 jlt-mt-2 jlt-bg-slate-200">
          <span>{couponCode}</span>
          <span className="jlt-cursor-pointer jlt-text-red-600" onClick={handleResetCoupon}>
            x
          </span>
        </div>
      ) : null} */}
    </div>
  );
};

export default Coupon;
